import styled from "styled-components";

const ErrorContainer = styled.div`
  color: #e74c3c;
  padding: 20px;
  text-align: center;
  background: #fdf3f2;
  border-radius: 4px;
  margin: 20px 0;
`;

export default ErrorContainer;
